export default "__VITE_ASSET__B5NaKr0A__ 400w, __VITE_ASSET__CHjCTNiG__ 800w, __VITE_ASSET__Cbot551a__ 1200w";